import { render, staticRenderFns } from "./PairInspector.vue?vue&type=template&id=40b62c29&"
import script from "./PairInspector.vue?vue&type=script&lang=js&"
export * from "./PairInspector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports